import React, { useState, useEffect } from 'react';

import { FaSearch } from "react-icons/fa";
import { IoCloseCircleSharp } from "react-icons/io5";

import { isMobile, isTablet } from 'react-device-detect';

const SearchBar = ({ onSearch, mapboxTokenRef, globalRefs, globalState }) => {

  const [searchTerm, setSearchTerm] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [searchOpen, setSearchOpen] = useState(false);

  let polygonCustomLayerRef = globalRefs.polygonCustomLayerRef;

  const fetchGeocodeData = async (query) => {
    const accessToken = mapboxTokenRef.current;
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?access_token=${accessToken}&limit=5`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      return data.features;
    } catch (error) {
      console.error('Error fetching geocoding data:', error);
    }

    return [];
  };

  useEffect(() => {
    if (searchTerm.length > 2) {
      const delayDebounceFn = setTimeout(async () => {
        const results = await fetchGeocodeData(searchTerm);
        setSuggestions(results);
      }, 300);

      return () => clearTimeout(delayDebounceFn);
    } else {
      setSuggestions([]);
    }
  }, [searchTerm]);

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const handleSuggestionClick = async (place_name) => {
    try {
      const results = await fetchGeocodeData(place_name);

      if (results.length > 0) {
        const [longitude, latitude] = results[0].center;
        polygonCustomLayerRef.current.cameraFlyToLatLong(latitude, longitude);
      }
    } catch (error) {
      console.error('Error fetching geocoding data:', error);
    } finally {
      setSuggestions([]);
    }
  };

  const toggleSearch = () => {
    setSearchOpen((open) => !open);
    setSuggestions([]);

    if (searchOpen) {
      setSearchTerm('');
    }
  };

  let mobileStatus = isMobile ? "mobile" : "not-mobile";

  if (isTablet) {
    mobileStatus = "tablet";
  }

  return (
    <div>
      {!searchOpen ? (
        <button
          type="button"
          className={`searchToggle ${mobileStatus}`}
          onClick={toggleSearch}
          aria-label="Open search"
        >
          <FaSearch />
        </button>
      ) : (
        <>
          <form onSubmit={handleSubmit}>
            <input
              className={`searchBar ${mobileStatus}`}
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleChange}
              autoFocus
            />
          </form>

          <button
            type="button"
            className={`searchToggle ${mobileStatus}`}
            onClick={toggleSearch}
            aria-label="Close search"
          >
            <IoCloseCircleSharp />
          </button>
        </>
      )}

      {suggestions.length > 0 && (
        <ul className={`suggestions ${mobileStatus}`}>
          {suggestions.map((suggestion) => (
            <li
              key={suggestion.id}
              onClick={() =>
                handleSuggestionClick(suggestion.place_name)
              }
            >
              {suggestion.place_name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchBar;
